import uuidv4 from "uuid";
import React from "react";

const illustrations = [
  {
    key: uuidv4(),
    content: <img src="assets/images/illustrations/mac.png" alt="1" />,
  },
  {
    key: uuidv4(),
    content: <img src="assets/images/illustrations/reddit.png" alt="2" />,
  },
  {
    key: uuidv4(),
    content: <img src="assets/images/illustrations/invente.png" alt="3" />,
  },
  {
    key: uuidv4(),
    content: <img src="assets/images/illustrations/nftiac.png" alt="4" />,
  },
  {
    key: uuidv4(),
    content: <img src="assets/images/illustrations/album.png" alt="5" />,
  },
  {
    key: uuidv4(),
    content: <img src="assets/images/illustrations/loyalty.png" alt="6" />,
  },
  {
    key: uuidv4(),
    content: <img src="assets/images/illustrations/cam.png" alt="7" />,
  },
  {
    key: uuidv4(),
    content: <img src="assets/images/illustrations/dominos.png" alt="6" />,
  },
];

export default illustrations;
